"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrustPilotAndDefaqtoWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var TrustpilotWidget_1 = require("../../../components/TrustpilotWidget");
var React = require("react");
var TrustPilotAndDefaqtoWidget = /** @class */ (function (_super) {
    __extends(TrustPilotAndDefaqtoWidget, _super);
    function TrustPilotAndDefaqtoWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TrustPilotAndDefaqtoWidget.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)("div", { className: "premium-output", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex-logo-container", children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(TrustpilotWidget_1.default, {}) }), (0, jsx_runtime_1.jsx)("img", { src: "/img/DefaqtoLogoHome.svg", alt: "Home Defaqto logo", className: "logo-img" })] }) }));
    };
    return TrustPilotAndDefaqtoWidget;
}(React.Component));
exports.TrustPilotAndDefaqtoWidget = TrustPilotAndDefaqtoWidget;
//# sourceMappingURL=TrustPilotAndDefaqtoWidget.js.map